"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatUniqConcat = exports.convertArrayToObject = exports.concatTwoArraysAsUniqByKey = exports.asyncFilter = void 0;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/**
 * When you want to use the filter function but asynchronously wait for some stuff inside
 * @param arr: The array to filter trough
 * @param predicate: The predicate function that will await something and then return true/false like a normal filter
 * @returns -> A new array filtered by the predicate function
 */

var asyncFilter = exports.asyncFilter = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (arr, predicate) {
    var results = yield Promise.all(arr.map(predicate));
    return arr.filter((_v, index) => results[index]);
  });
  return function asyncFilter(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Used to concat and uniq two arrays of objects and identify the duplicates by a key.
 * Could also be done using lodash like this : _.uniqBy([...newValues, ...oldValues], key)
 * @param newValues: array of objects to add.
 * @param oldValues: array of objects already stored.
 * @param key: the key used to identify the duplicates
 * @returns -> The new array
 */

var concatTwoArraysAsUniqByKey = (newValues, oldValues, key) => {
  return [...newValues.reduce((acc, newValue) => {
    if (!acc.find(oldValue => oldValue[key] === newValue[key])) {
      acc.push(newValue);
    }
    return acc;
  }, oldValues)];
};
exports.concatTwoArraysAsUniqByKey = concatTwoArraysAsUniqByKey;
var convertArrayToObject = (arr, key) => {
  var obj = {};
  if (key && arr !== null && arr !== void 0 && arr.length) arr.map(el => el[key] ? obj[el[key]] = el : null);
  return obj;
};

// TODO: optimize
exports.convertArrayToObject = convertArrayToObject;
var flatUniqConcat = exports.flatUniqConcat = function flatUniqConcat(initial) {
  for (var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }
  return [].concat(...initial, ...others).filter((elem, pos, arr) => arr.indexOf(elem) === pos);
};